module.exports = __webpack_public_path__ + "784c9f6f6839bbfc783f47de1e53fcb8.pdf";